import React, { useState, useEffect } from 'react';
import Input from '../Input';
import Modal from '../Modal';
import { useConfirm } from '../ConfirmContext';
import * as validation from '../Validation';
import CheckBox from '../CheckBox';
import RulesModal from './RulesModal';

const WebsiteModal = ({website, websites, setVisible, saveWebsite}) => {
  let confirm = useConfirm();
  let [domain, setDomain] = useState(null);
  let [detection, setDetection] = useState(null);
  let [slowRetraining, setSlowRetraining] = useState(null);
  let [title, setTitle] = useState(null);
  let [config, setConfig] = useState(null);
  let [rulesModalVisible, setRulesModalVisible] = useState(false);

  useEffect(() => {
    if (website) {
      setDomain(website.domain);
      setDetection(website.detection);
      setSlowRetraining(website.slowRetraining);
      setConfig(website.config);
      setTitle('Edit Website');
    }
    else {
      setDomain('');
      setDetection('disabled');
      setSlowRetraining(false);
      setConfig({ action: 'ignore',
                  is_active: false,
                  rules: [] });
      setTitle('Add Website');
    }

  }, [website]);

  return (
    <>
      {rulesModalVisible && <RulesModal setVisible={setRulesModalVisible}
                                        config={config}
                                        setConfig={setConfig}/>}
      <Modal isOpen={true}
             zIndex={200}>
        <div style={{
               background: 'linear-gradient(gray, transparent)',
               position: 'absolute',
               transform: 'translate(-50%, -50%)',
               top: '50%',
               left: '50%',
               width: '600px',
               borderRadius: '10px',
             }}>
          <div
            style={{
              margin: '1px',
              borderRadius: '10px',
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              padding: '20px',
              backgroundColor: 'black',
            }}>
            <div style={{
                   display: 'flex',
                   flexDirection: 'column',
                   justifyContent: 'space-between',
                   width: '100%',
                   gap: '10px',

                 }}>
              <span style={{fontSize: '22px',
                            fontWeight: 'bold',
                           }}>
                {title}
              </span>

              <Input label='DOMAIN'
                     value={domain}
                     onChange={(e) => setDomain(e.target.value)} />

              <div style={{display: 'flex',
                           flexDirection: 'row',
                           alignItems: 'center',
                           justifyContent: 'space-between',
                           width: '100%',
                           gap: '10px',
                           whiteSpace: 'nowrap',
                          }}>
                <select style={{width: '100%',
                                padding: '10px',
                                borderRadius: '5px',
                                border: '1px solid #e0e0e0',
                                backgroundColor: 'black',
                                color: 'white',
                               }}
                        value={detection}
                        onChange={(e) => setDetection(e.target.value)}>
                  <option value='disabled'>Disabled</option>
                  <option value='detection_only'>Detection Only</option>
                  <option value='true_traffic'>True Traffic</option>
                </select>
                <span>Detection type</span>
              </div>

              <div style={{display: 'flex',
                           gap: '10px',
                           alignItems: 'center',
                          }}>
                <CheckBox
                  checked={slowRetraining}
                  onChange={(e) => {
                    setSlowRetraining(e.target.checked);
                  }}/>

                <span style={{color: 'gray',
                              fontSize: '13px',
                             }}>
                  Slow retraining
                </span>
              </div>

              <div style={{alignItems: 'center',
                           padding: '10px 20px',
                           border: '1px solid #e0e0e0',
                           borderRadius: '5px',
                           cursor: 'pointer',
                           fontWeight: 'bold',
                           display: 'flex',
                           justifyContent: 'center',
                           width: 'fit-content',
                          }}
                   onClick={() => setRulesModalVisible(true)}>
                Rules
              </div>

              <div style={{display: 'flex',
                           flexDirection: 'row',
                           alignItems: 'center',
                           marginTop: '10px',
                           gap: '10px',
                           justifyContent: 'center',
                          }}>
                <div style={{alignItems: 'center',
                             padding: '10px 20px',
                             border: '1px solid #e0e0e0',
                             borderRadius: '5px',
                             cursor: 'pointer',
                             fontWeight: 'bold',
                             alignSelf: 'flex-end',
                             display: 'flex',
                             justifyContent: 'center',
                            }}
                     onClick={() => setVisible(false)}>
                  Cancel
                </div>
                <div style={{alignItems: 'center',
                             padding: '10px 20px',
                             backgroundColor: '#009de6',
                             color: 'white',
                             borderRadius: '5px',
                             cursor: 'pointer',
                             fontWeight: 'bold',
                             alignSelf: 'flex-end',
                             display: 'flex',
                             justifyContent: 'center',
                            }}
                     onClick={async () => {
                       if (validation.getDomainWarning(domain)) {
                         await confirm('Please use a valid domain', true);
                         return;
                       }

                       let domains = websites.map((w) => w.domain);

                       if (website === null && domains.includes(domain)) {
                         await confirm('This domain already exists', true);
                         return;
                       }

                       saveWebsite({domain, detection, slowRetraining, config});
                       setVisible(false);
                     }}>
                  {website ? 'Save' : 'Add'}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default WebsiteModal;
